module.exports = __webpack_public_path__ + "static/media/Bay5.4ec94dc4.JPG";